import pluralize from 'pluralize';

import { AlertTriangleIcon, CheckCircleIcon, Tool02Icon } from '@/assets/icons';
import { Separator, Tooltip, TooltipContent, TooltipTrigger } from '@/components/common';

import { ILinks } from '@/features/regulatory-intake/interfaces';

interface IProcessingStatusOverview {
  links?: ILinks;
  isNA: boolean;
}

export const ProcessingStatusOverview = ({ links, isNA }: IProcessingStatusOverview) => {
  const inProgressCount = (links?.pending || 0) + (links?.captchaCheck || 0);
  return (
    <div className="h-[38px] rounded-lg w-fit bg-opacity-dark-5 border border-neutral-4 flex flex-row justify-center items-center gap-2 px-4 text-neutral-9">
      {isNA ? (
        <span className="font-semibold">N/A</span>
      ) : (
        <>
          {!links || links.total === 0 ? (
            <span className="font-semibold">0 links</span>
          ) : (
            <>
              <span className="font-semibold">
                Total {links.total} {pluralize('link', links.total)}:
              </span>
              <div className="flex flex-row justify-center items-center gap-3">
                {links?.resolved > 0 && (
                  <>
                    <div className="flex flex-row justify-center items-center gap-2">
                      <CheckCircleIcon className="size-4 text-semantic-success-base" />
                      {links.resolved} Resolved
                    </div>
                    {(links.pending > 0 || links.captchaCheck > 0) && (
                      <Separator className="h-4 w-[1px] bg-neutral-5" />
                    )}
                  </>
                )}
                {inProgressCount > 0 && (
                  <>
                    <Tooltip>
                      <TooltipTrigger className="cursor-default align-middle ml-2">
                        <div className="flex flex-row justify-center items-center gap-2">
                          <Tool02Icon className="size-4 text-semantic-info-base" />
                          {inProgressCount} In Progress
                        </div>
                      </TooltipTrigger>
                      <TooltipContent
                        className="text-body-sm font-medium rounded-xs"
                        size="lg"
                        side="bottom"
                      >
                        {`${links.pending} Pending; ${links.captchaCheck} CAPTCHA check`}
                      </TooltipContent>
                    </Tooltip>
                    {links.attention > 0 && <Separator className="h-4 w-[1px] bg-neutral-5" />}
                  </>
                )}
                {links.attention > 0 && (
                  <div className="flex flex-row justify-center items-center gap-2">
                    <AlertTriangleIcon className="size-4 text-semantic-error-base" />
                    {links.attention} Attention
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
